export const REGISTRATIONS = 'md_registrations_GLOBAL';